import React from 'react';
import Navigation from '@/components/shared/Navigation';
import Footer from '@/components/shared/Footer';
import { Target, Shield, Globe } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#F9FAFB] font-sans">
      <Navigation />

      {/* Header */}
      <section className="bg-white py-16 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-4xl font-semibold text-[#0A2540] mb-4">
            About PulseShift Realty Partners
          </h1>
          <p className="text-xl text-[#2E2E2E] max-w-3xl">
            Offshore analyst-grade platform built by finance professionals for U.S. commercial real estate investors.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6">
          <div className="space-y-6 text-lg text-[#2E2E2E] leading-relaxed">
            <p>
              PulseShift Realty Partners was founded to address a critical gap in the U.S. commercial real estate market: 
              the need for institutional-quality analysis at offshore economics.
            </p>
            <p>
              We are not a freelancer marketplace. We are not a VA service. We are an offshore analyst platform 
              built by finance professionals who understand what institutional-grade work looks like.
            </p>
            <p>
              Our team operates as an extension of acquisitions, underwriting, and asset management teams — 
              delivering financial modeling, lease abstraction, market research, and investment analysis that meets 
              U.S. institutional standards.
            </p>
            <p>
              Every engagement is structured around accuracy, consistency, and process discipline. We train analysts 
              on client-specific workflows, operate in aligned time zones, and build long-term partnerships with 
              investment teams.
            </p>
          </div>
        </div>
      </section>

      {/* Core Principles */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-semibold text-[#0A2540] mb-12 text-center">
            Core Principles
          </h2>
          <div className="grid md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0A2540] rounded mb-6">
                <Target className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-[#0A2540] mb-4">
                Accuracy First
              </h3>
              <p className="text-[#2E2E2E] leading-relaxed">
                All work is structured around institutional standards. Outputs are built for review, validation, 
                and integration with existing workflows.
              </p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0A2540] rounded mb-6">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-[#0A2540] mb-4">
                Process Discipline
              </h3>
              <p className="text-[#2E2E2E] leading-relaxed">
                Consistency matters in financial analysis. We train teams on client-specific processes and 
                maintain strict quality control standards.
              </p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0A2540] rounded mb-6">
                <Globe className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-[#0A2540] mb-4">
                Seamless Integration
              </h3>
              <p className="text-[#2E2E2E] leading-relaxed">
                Time-zone alignment, structured communication, and long-term team continuity. We operate as an 
                extension of your team.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Location Note */}
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-6">
          <div className="bg-white p-8 rounded-lg border border-gray-200">
            <h3 className="text-xl font-semibold text-[#0A2540] mb-4">
              Offshore Operations
            </h3>
            <p className="text-[#2E2E2E] leading-relaxed">
              PulseShift Realty Partners operates from India, providing cost-efficient analyst support to U.S.-based clients. 
              Our teams are time-zone aligned and trained on U.S. institutional standards.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;